const apiEndpoint = ( window ? (window as any).env?.REACT_APP_API_ENDPOINT : process.env.REACT_APP_API_ENDPOINT ) || "http://localhost:8080";

export const VideoResourceUrl = (filename: string): string => {
  return `${apiEndpoint}/${filename}`;
}

